import axios from "axios";
import qs from "query-string";
import { DEVICE } from "../constants";
import { getUid } from "../utils/fingerprint";

export default class BaseDataProvider {
    _getFullObject(context = {}) {
        if (context.screen >= 960) {
            return 11115;
        }

        return 12013;
    }

    _getPreviewObject(context = {}) {
        return 11071;
    }

    getObject(context = {}) {
        if (context.isFull) {
            return this._getFullObject(context);
        } else {
            return this._getPreviewObject(context);
        }
    }

    getScrollObject(context) {
        return this.getObject(context);
    }

    getLoadParams(object, context) {
        const params = {};

        if (context.sid) {
            params.sid = context.sid;
        }

        if (context.rcid) {
            params.rcid = context.rcid;
        }

        return params;
    }

    spliceData(teasers, info) {
        const data = {};

        for (let [blockName, spliceArg] of Object.entries(info)) {
            data[blockName] = teasers.splice(spliceArg[0], spliceArg[1]);
        }

        return data;
    }

    reindex(data, reindex) {
        // reindex  = [[oldIndex, newIndex], [oldIndex, newIndex]]

        let res = {};

        reindex.forEach(function(item) {
            let newIndex = item[0] - 1;
            let oldIndex = item[1] - 1;
            res[newIndex] = data[oldIndex];
        });

        reindex.forEach(function(item) {
            let newIndex = item[0] - 1;
            let oldIndex = item[1] - 1;
            data[newIndex] = res[newIndex];
        });
    }

    getDataUrl(context) {
        if(context.isFprProvided) {
            return '//data.24smi.net/informer';
        };
        return '/api/news/';
    }

    async load(object, num, context, scrollNum) {
        const uid = getUid();

        const params = this.getLoadParams(object, context);

        let result = [];

        let emptyResponseCnt = 0;

        while (result.length < num && emptyResponseCnt != 3) {
            let needToLoad = num - result.length;

            let queryDict = Object.assign(
                { output: "json" },
                {
                    num: needToLoad,
                    object
                },
                params,
                {
                    chash: uid,
                    glavnoe_news_id: context.news_id,
                    subid_glavnoe: context.news_id
                }
            );

            let queryString = qs.stringify(queryDict);

            const baseUrl = this.getDataUrl(context);
            let url = `${baseUrl}?${queryString}`;

            const response = await axios.get(url);

            if (response.data.news.length == 0) {
                emptyResponseCnt += 1;
            }

            const teasers = response.data.news;

            result = result.concat(teasers);
        }

        return this.preprocessTeasers(result, context, scrollNum, object);
    }

    preprocessTeasers(teasers, context, scrollNum, object) {
        teasers.forEach((teaser, i) => {
            teaser.cat = teaser.cat.replace(" - Реклама", "");
            // teaser.url = teaser.url.replace("https://ex.24smi.info", "");
            // teaser.img = teaser.img.replace("//img.24smi.net", "//news.glavnoe.io/img");
            teaser.index = i;
            teaser.scrollNum = scrollNum;
            teaser.object = object;

            teaser.image_color_primary = teaser.icp;

            if (teaser.image_color_primary) {
                const rgb = teaser.image_color_primary.split(",");
                if (rgb.length == 3) {
                    teaser.image_color_primary = rgb;
                } else {
                    teaser.image_color_primary = undefined;
                }
            }

            if (context.queryString.debug) {
                teaser.title = `${i + 1}/${teasers.length}(${object}) ${teaser.title}`;
            }
        });

        return teasers;
    }

    updateState(state, data) {
        throw new Error("not implemented");
    }

    loadInitialData(context) {
        console.log("loadInitialData");

        return new Promise(resolve => {});
    }

    loadScrollData(context, scrollNum) {
        console.log("loadScrollData");

        return new Promise(resolve => {});
    }
}
